module.exports = __webpack_public_path__ + "img/question-set-file.3709de33.png";